var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-keyboard-backspace",
    "data-name": "Icon material-keyboard-backspace",
    d: "M31.5,16.5H10.245l5.37-5.385L13.5,9l-9,9,9,9,2.115-2.115L10.245,19.5H31.5Z",
    transform: "translate(-4.5 -9)",
    fill: "#242529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.bec4eb18082c306bc6cc438dd26a5d32.svg";
export { ForwardRef as ReactComponent };